import { Button, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Radio, RadioGroup, Select, TextField, Typography } from '@mui/material';
import React, { useState } from 'react'
import { Controller, useForm, useFormContext, useWatch } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { addressTypeArray, countryList, provinceList, radioColorSx, radioOptionArray } from 'store/constant';
import axiosInstance from 'custom-axios';
import { ToastContainer, toast } from 'react-toastify';
import { useParams } from 'react-router';


const AddressInformation = ({ activeStep, setActiveStep, addressRef }) => {

    const { id } = useParams();
    let userGetId = localStorage.getItem('user_get_id')
    const userId = id ? id : userGetId;

    const { register, control, watch, handleSubmit, trigger, setValue, getValues, formState: { errors } } = useFormContext();

    const sameMailingAddress = useWatch({ control, name: 'same_mailing_address' });
    const thirdPartyAddress = useWatch({ control, name: 'third_party_address' });
    const sFirstName = useWatch({ control, name: 's_first_name' });

    React.useImperativeHandle(addressRef, () => ({
        triggerValidation: async () => {
            const isValid = await trigger();
            return isValid;
        }
    }));


    const handleRoleBack = async () => {
        let endPoint = `api/change-form-step`;

        const submitData = { user_id: userId ? userId : 0, parent_step: 0, child_step: activeStep - 1 }

        try {
            const response = await axiosInstance.post(endPoint, submitData);

            if (response.status === 200) {
                setActiveStep(activeStep - 1);
            }

        } catch (error) {
            // console.error(error)
            toast.error('An error occurred when navigating back.')
        }
    };

    const submitPersonalInfo = async (data) => {

        let endPoint = `api/save-user-address-info`;

        const submitData = { ...data, user_id: userId ? userId : 0, parent_step: 0, child_step: activeStep + 1 }

        try {
            const response = await axiosInstance.post(endPoint, submitData);

            if (response.status === 200) {
                setActiveStep(activeStep + 1);
            }

        } catch (error) {
            // console.error(error)
        }
    }

    return (
        <>
            <form onSubmit={handleSubmit(submitPersonalInfo)}>

                <Grid container spacing={2} className='p-4'>

                    <Grid item xs={12}>
                        <Typography component={'h3'} className='form-head-gray-title'>Legal Address</Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <label htmlFor="l_address_type" className='font15px padding10px padding-left0'>Address Type</label>

                        <FormControl fullWidth size="small">
                            <InputLabel id="l-address-type">Address Type</InputLabel>
                            <Controller
                                name="l_address_type"
                                control={control}
                                defaultValue=""
                                render={({ field }) => (
                                    <Select
                                        {...field}
                                        labelId="l-address-type"
                                        label="Address Type"
                                        onChange={(e) => {
                                            field.onChange(e);
                                            // changeAddressInfo?.(e);
                                        }}
                                        classes={{ select: "custom-select-label" }}
                                        MenuProps={{
                                            disableScrollLock: true,
                                            PaperProps: { sx: { maxHeight: 200 } }
                                        }}
                                    >
                                        {addressTypeArray?.map((row) => (
                                            <MenuItem key={row.value} value={row.value}>
                                                {row.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                )}
                            />
                        </FormControl>
                    </Grid>

                    <Grid item xs={6}>
                        <TextField
                            label="Civic/RR No"
                            fullWidth
                            size="small"
                            {...register('l_rr_no')}
                        />
                    </Grid>


                    <Grid item xs={6}>
                        <TextField
                            label="Unit No"
                            fullWidth
                            size="small"
                            {...register('l_unit_no')}
                        />
                    </Grid>

                    <Grid item xs={6}>
                        <TextField
                            label="Unit Type"
                            fullWidth
                            size="small"
                            {...register('l_unit_type')}
                        />
                    </Grid>

                    <Grid item xs={6}>
                        <TextField
                            label="Street No"
                            fullWidth
                            size="small"
                            {...register('l_street_no', { required: true })}
                            error={Boolean(errors && errors['l_street_no'])}
                        />
                    </Grid>

                    <Grid item xs={6}>
                        <TextField
                            label="Street Name"
                            fullWidth
                            size="small"
                            {...register('l_street_name', { required: true })}
                            error={Boolean(errors && errors['l_street_name'])}
                        />
                    </Grid>

                    <Grid item xs={6}>
                        <TextField
                            label="Street Type"
                            fullWidth
                            size="small"
                            {...register('l_street_type', { required: true })}
                            error={Boolean(errors && errors['l_street_type'])} />
                    </Grid>

                    <Grid item xs={6}>
                        <TextField
                            label="City"
                            fullWidth
                            size="small"
                            {...register('l_city', { required: true })}
                            error={Boolean(errors && errors['l_city'])}
                        />
                    </Grid>

                    <Grid item xs={6}>
                        <FormControl
                            fullWidth
                            size="small"
                            error={Boolean(errors?.l_province)}
                        >
                            <InputLabel id="select-tpi-province">Province</InputLabel>

                            <Controller
                                name="l_province"
                                control={control}
                                rules={{ required: "Province is required" }}
                                render={({ field }) => (
                                    <Select
                                        {...field}
                                        value={field.value ?? ''}
                                        labelId="select-tpi-province"
                                        id="select-tpi-province"
                                        label="Province"
                                        classes={{ select: "custom-select-label" }}
                                        MenuProps={{
                                            disableScrollLock: true,
                                            PaperProps: { sx: { maxHeight: 200 } }
                                        }}
                                        onChange={(e) => {
                                            field.onChange(e);
                                            // changeAddressInfo(e); // trigger your custom logic
                                        }}
                                    >
                                        <MenuItem value={0}>Select Province</MenuItem>
                                        {provinceList.map((option) => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                )}
                            />
                        </FormControl>

                    </Grid>


                    <Grid item xs={6}>
                        <FormControl fullWidth size="small" error={Boolean(errors?.l_country)}>
                            <InputLabel id="select-l-country">Country</InputLabel>
                            <Controller
                                name="l_country"
                                control={control}
                                rules={{ required: "Country is required" }}
                                render={({ field }) => (
                                    <Select
                                        {...field}
                                        labelId="select-l-country"
                                        label="Country"
                                        classes={{ select: "custom-select-label" }}
                                        MenuProps={{
                                            disableScrollLock: true,
                                            PaperProps: { sx: { maxHeight: 200 } },
                                        }}
                                    >
                                        {countryList.map((option) => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                )}
                            />
                        </FormControl>

                    </Grid>


                    <Grid item xs={6}>
                        <TextField
                            label="Postal Code"
                            fullWidth
                            size="small"
                            id="l-postal-code"
                            {...register('l_postal_code', { required: true })}
                            error={Boolean(errors && errors['l_postal_code'])}

                        />
                    </Grid>
                    {/* <Grid item xs={6}></Grid> */}


                    <Grid item xs={4} className='align-content-center'>
                        <label htmlFor="same-legal-address" className='font15px'>Is mailing address different then the legal address?</label>
                    </Grid>

                    <Grid item xs={3}>
                        <FormControl component="fieldset">
                            <Controller
                                name="same_mailing_address"
                                control={control}
                                defaultValue=""
                                rules={{ required: "Please select an option" }}
                                render={({ field }) => (
                                    <RadioGroup
                                        row
                                        aria-labelledby="same-legal-address"
                                        {...field}
                                        onChange={(e) => {
                                            field.onChange(e);
                                        }}
                                    >
                                        {radioOptionArray.map((option) => (
                                            <FormControlLabel
                                                key={option.value}
                                                value={option.value}
                                                control={<Radio sx={radioColorSx} />}
                                                label={option.label}
                                            />
                                        ))}
                                    </RadioGroup>
                                )}
                            />
                        </FormControl>

                    </Grid>
                    <Grid item xs={5}></Grid>

                    {sameMailingAddress == 1 ?

                        <>
                            <Grid item xs={12}>
                                <Typography component={'h3'}>Mailing Address</Typography>
                            </Grid>



                            <Grid item xs={12}>
                                <label htmlFor="m_address_type" className='font15px padding10px padding-left0'>Address Type</label>

                                <FormControl fullWidth size="small" error={Boolean(errors?.m_address_type)}>
                                    <InputLabel id="m-address-type">Address Type</InputLabel>
                                    <Controller
                                        name="m_address_type"
                                        control={control}
                                        rules={{ required: "Address Type is required" }}
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                value={field.value ?? ''}
                                                labelId="m-address-type"
                                                id="m-address-type"
                                                label="Address Type"
                                                classes={{ select: "custom-select-label" }}
                                                MenuProps={{
                                                    disableScrollLock: true,
                                                    PaperProps: { sx: { maxHeight: 200 } }
                                                }}
                                            >
                                                <MenuItem value="">Select Address Type</MenuItem>
                                                {addressTypeArray?.map((row) => (
                                                    <MenuItem key={row.value} value={row.value}>
                                                        {row.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        )}
                                    />
                                </FormControl>

                            </Grid>


                            <Grid item xs={6}>
                                <TextField
                                    label="Civic/RR No"
                                    fullWidth
                                    size="small"
                                    {...register('m_rr_no')}
                                />
                            </Grid>

                            <Grid item xs={6}>
                                <TextField
                                    label="Unit No"
                                    fullWidth
                                    size="small"
                                    {...register('m_unit_no')}
                                />
                            </Grid>

                            <Grid item xs={6}>
                                <TextField
                                    label="Unit Type"
                                    fullWidth
                                    size="small"
                                    {...register('m_unit_type')}
                                />
                            </Grid>

                            <Grid item xs={6}>
                                <TextField
                                    label="Street No"
                                    fullWidth
                                    size="small"
                                    {...register('m_street_no', { required: true })}
                                    error={Boolean(errors && errors['m_street_no'])}
                                />
                            </Grid>

                            <Grid item xs={6}>
                                <TextField
                                    label="Street Name"
                                    fullWidth
                                    size="small"
                                    {...register('m_street_name', { required: true })}
                                    error={Boolean(errors && errors['m_street_name'])}
                                />
                            </Grid>

                            <Grid item xs={6}>
                                <TextField
                                    label="Street Type"
                                    fullWidth
                                    size="small"
                                    {...register('m_street_type', { required: true })}
                                    error={Boolean(errors && errors['m_street_type'])}
                                />
                            </Grid>

                            <Grid item xs={6}>
                                <TextField
                                    label="City"
                                    fullWidth
                                    size="small"
                                    {...register('m_city', { required: true })}
                                    error={Boolean(errors && errors['m_city'])}
                                />
                            </Grid>

                            <Grid item xs={6}>
                                <FormControl fullWidth size="small" error={Boolean(errors?.m_province)}>
                                    <InputLabel id="select-m-province">Province</InputLabel>
                                    <Controller
                                        name="m_province"
                                        control={control}
                                        rules={{ required: "Province is required" }}
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                value={field.value ?? ''}
                                                labelId="select-m-province"
                                                id="select-m-province"
                                                label="Province"
                                                classes={{ select: "custom-select-label" }}
                                                MenuProps={{
                                                    disableScrollLock: true,
                                                    PaperProps: { sx: { maxHeight: 200 } }
                                                }}
                                            >
                                                <MenuItem value="">Select Province</MenuItem>
                                                {provinceList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        )}
                                    />
                                </FormControl>

                            </Grid>


                            <Grid item xs={6}>
                                <FormControl fullWidth size="small" error={Boolean(errors?.m_country)}>
                                    <InputLabel id="select-m-country">Country</InputLabel>
                                    <Controller
                                        name="m_country"
                                        control={control}
                                        rules={{ required: "Country is required" }}
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                value={field.value ?? ''}
                                                labelId="select-m-country"
                                                id="select-m-country"
                                                label="Country"
                                                classes={{ select: "custom-select-label" }}
                                                MenuProps={{
                                                    disableScrollLock: true,
                                                    PaperProps: { sx: { maxHeight: 200 } }
                                                }}
                                            >
                                                <MenuItem value="">Select Country</MenuItem>
                                                {countryList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        )}
                                    />
                                </FormControl>

                            </Grid>


                            <Grid item xs={6}>
                                <TextField
                                    label="Postal Code"
                                    fullWidth
                                    size="small"
                                    id="m-postal-code"
                                    {...register('m_postal_code', { required: true })}
                                    error={Boolean(errors && errors['m_postal_code'])}
                                />
                            </Grid>
                            {/* <Grid item xs={6}></Grid> */}

                        </>
                        : null}


                    {/* ----------------------THIRD PARTY ADDRESS -------- */}

                    <Grid item xs={4} className='align-content-center'>
                        <label htmlFor="third-party-address" className='font15px'>Is there a third party address same for {sFirstName ? sFirstName : 'Your Spouse'}?</label>
                    </Grid>

                    <Grid item xs={3}>
                        <FormControl component="fieldset" error={Boolean(errors?.third_party_address)}>
                            <Controller
                                name="third_party_address"
                                control={control}
                                rules={{ required: "Please select an option" }}
                                render={({ field }) => (
                                    <RadioGroup
                                        {...field}
                                        row
                                        aria-labelledby="third-party-address"
                                        id="third-party-address"
                                    >
                                        {radioOptionArray.map((option) => (
                                            <FormControlLabel
                                                key={option.value}
                                                value={option.value}
                                                control={<Radio sx={radioColorSx} />}
                                                label={option.label}
                                            />
                                        ))}
                                    </RadioGroup>
                                )}
                            />
                        </FormControl>

                    </Grid>
                    <Grid item xs={5}></Grid>

                    {thirdPartyAddress == 1 ?
                        <>
                            <Grid item xs={12}>
                                <Typography component={'h3'}>Third Party Address</Typography>
                            </Grid>

                            <Grid item xs={12}>
                                <label htmlFor="tpi_address_type" className='font15px padding10px padding-left0'>Address Type</label>
                                <FormControl fullWidth size="small">
                                    <InputLabel id="tpi-address-type">Address Type</InputLabel>
                                    <Controller
                                        name="tp_address_type"
                                        control={control}
                                        rules={{ required: "Address Type is required" }}
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                labelId="tpi-address-type"
                                                label="Address Type"
                                                classes={{ select: "custom-select-label" }}
                                                MenuProps={{
                                                    disableScrollLock: true,
                                                    PaperProps: { sx: { maxHeight: 200 } },
                                                }}
                                            >
                                                {addressTypeArray?.map((row) => (
                                                    <MenuItem key={row.value} value={row.value}>
                                                        {row.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        )}
                                    />
                                </FormControl>

                            </Grid>


                            <Grid item xs={6}>
                                <TextField
                                    label="Civic/RR No"
                                    fullWidth
                                    size="small"
                                    {...register("tp_rr_no")}
                                />
                            </Grid>

                            <Grid item xs={6}>
                                <TextField
                                    label="Unit No"
                                    fullWidth
                                    size="small"
                                    {...register('tp_unit_no')}
                                // error={Boolean(errors && errors['tp_unit_no'])}
                                />
                            </Grid>

                            <Grid item xs={6}>
                                <TextField
                                    label="Unit Type"
                                    fullWidth
                                    size="small"
                                    {...register('tp_unit_type')}
                                // error={Boolean(errors && errors['tp_unit_type'])}
                                />
                            </Grid>

                            <Grid item xs={6}>
                                <TextField
                                    label="Street No"
                                    fullWidth
                                    size="small"
                                    {...register('tp_street_no', { required: true })}
                                    error={Boolean(errors && errors['tp_street_no'])}
                                />
                            </Grid>

                            <Grid item xs={6}>
                                <TextField
                                    label="Street Name"
                                    fullWidth
                                    size="small"
                                    {...register('tp_street_name', { required: true })}
                                    error={Boolean(errors && errors['tp_street_name'])}
                                />
                            </Grid>

                            <Grid item xs={6}>
                                <TextField
                                    label="Street Type"
                                    fullWidth
                                    size="small"
                                    {...register('tp_street_type', { required: true })}
                                    error={Boolean(errors && errors['tp_street_type'])}
                                />
                            </Grid>

                            <Grid item xs={6}>
                                <TextField
                                    label="City"
                                    fullWidth
                                    size="small"
                                    {...register('tp_city', { required: true })}
                                    error={Boolean(errors && errors['tp_city'])}
                                />
                            </Grid>

                            <Grid item xs={6}>
                                <FormControl fullWidth size="small" error={Boolean(errors?.tp_province)}>
                                    <InputLabel id="select-tpi-province">Province</InputLabel>
                                    <Controller
                                        name="tp_province"
                                        control={control}
                                        rules={{ required: "Province is required" }}
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                labelId="select-tpi-province"
                                                label="Province"
                                                classes={{ select: "custom-select-label" }}
                                                MenuProps={{
                                                    disableScrollLock: true,
                                                    PaperProps: { sx: { maxHeight: 200 } },
                                                }}
                                            >
                                                {provinceList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        )}
                                    />
                                </FormControl>

                            </Grid>


                            <Grid item xs={6}>
                                <FormControl fullWidth size="small" error={Boolean(errors?.tp_country)}>
                                    <InputLabel id="select-tpi-country">Country</InputLabel>
                                    <Controller
                                        name="tp_country"
                                        control={control}
                                        rules={{ required: "Country is required" }}
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                labelId="select-tpi-country"
                                                label="Country"
                                                classes={{ select: "custom-select-label" }}
                                                MenuProps={{
                                                    disableScrollLock: true,
                                                    PaperProps: { sx: { maxHeight: 200 } },
                                                }}
                                            >
                                                {countryList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        )}
                                    />
                                </FormControl>

                            </Grid>


                            <Grid item xs={6}>
                                <TextField
                                    label="Postal Code"
                                    fullWidth
                                    size="small"
                                    id="m-postal-code"
                                    {...register('tp_postal_code', { required: true })}
                                    error={Boolean(errors && errors['tp_postal_code'])}
                                />
                            </Grid>
                            <Grid item xs={6}></Grid>

                        </>
                        : null}
                </Grid>


                <Grid item xs={12} sm={6} className='pt-3 text-center'>
                    <Button variant='contained' className='m-3 raintree-btn-green' onClick={handleRoleBack}>
                        Back
                    </Button>
                    <Button variant='contained' className='m-3 raintree-btn-green' type='submit'>
                        Next
                    </Button>
                </Grid>
            </form>
            <ToastContainer />
        </>
    )
}

export default AddressInformation